import { render } from "./DplaceListModal.vue?vue&type=template&id=6388aed4&scoped=true"
import script from "./DplaceListModal.vue?vue&type=script&lang=js"
export * from "./DplaceListModal.vue?vue&type=script&lang=js"

import "./DplaceListModal.vue?vue&type=style&index=0&id=6388aed4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6388aed4"

export default script